import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';
import { useFulfillmentPlannerContext } from '../context';

import type { MarketplaceServiceRecommendation } from './marketplace-service-recommendation-types';

type RequestedShipFromData = {
  recommendedShippingService?: string;
};

export const useMarketplaceServiceRecommendation = (): MarketplaceServiceRecommendation | null => {
  const { fulfillmentPlanId } = useFulfillmentPlannerContext();
  const requestedShipFrom: string | undefined = useSelector((state) => {
    const fulfillmentPlan = Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId });
    return fulfillmentPlan?.marketplaceData?.requestedShipFrom;
  });
  const marketplaceId: number | undefined = useSelector((state) => {
    const firstSalesOrder = Global.selectEntitiesSalesOrdersByFulfillmentPlanIds(state, {
      fulfillmentPlanIds: [fulfillmentPlanId],
    })[0];
    return firstSalesOrder?.store?.marketplaceId;
  });

  return useMemo(() => {
    if (!requestedShipFrom || !marketplaceId) {
      return null;
    }

    let data: RequestedShipFromData;
    try {
      data = JSON.parse(requestedShipFrom) as RequestedShipFromData;
    } catch {
      return null;
    }

    if (!data?.recommendedShippingService) {
      return null;
    }

    return { marketplaceId, recommendedShippingService: data.recommendedShippingService };
  }, [requestedShipFrom, marketplaceId]);
};
